import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { metadata, structuredData } from './metadata';
import { siteUrl } from './content';

export default function RouteMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const meta = metadata(path);
    document.title = meta.title;
    function setMeta(attribute: 'name' | 'property', key: string, content: string) {
      const element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`) ?? document.createElement('meta');
      element.setAttribute(attribute, key); element.content = content; document.head.appendChild(element);
    }
    setMeta('name', 'description', meta.description);
    setMeta('name', 'robots', meta.robots);
    for (const prefix of ['og', 'twitter']) {
      setMeta(prefix === 'og' ? 'property' : 'name', `${prefix}:title`, meta.title);
      setMeta(prefix === 'og' ? 'property' : 'name', `${prefix}:description`, meta.description);
    }
    setMeta('property', 'og:url', meta.canonical ?? siteUrl + path);
    document.head.querySelectorAll('link[rel="canonical"]').forEach(element => element.remove());
    if (meta.canonical) { const link = document.createElement('link'); link.rel = 'canonical'; link.href = meta.canonical; document.head.appendChild(link); }
    document.getElementById('seo-schema')?.remove();
    const schema = structuredData(path);
    if (schema) { const script = document.createElement('script'); script.id = 'seo-schema'; script.type = 'application/ld+json'; script.textContent = JSON.stringify(schema); document.head.appendChild(script); }
  }, [pathname]);
  return null;
}
